import { Flashcard as QuizletFlashcard } from "react-quizlet-flashcard"

interface FlashcardProps {
  question: string
  answer: string
  flipRef: React.MutableRefObject<() => void>
}

const Flashcard = ({ question, answer, flipRef }: FlashcardProps) => {
  return (
    <QuizletFlashcard
      className="!w-full"
      frontHTML={<h1 className="m-auto text-xl font-bold">{question}</h1>}
      frontCardStyle={{
        width: "100%",
        overflow: "hidden",
        padding: "30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f5f5f5",
        backgroundImage:
          "linear-gradient(180deg, rgba(0, 0, 0, 0) -0.11%, rgba(0, 0, 0, 0.048) 100.11%)",
        boxShadow: `
          0px 0px 3px 0px rgba(0, 0, 0, 0.55),
          0px 8px 40px 0px rgba(0, 0, 0, 0.25),
          0px 0px 3px 0px rgba(255, 255, 255, 0.1) inset
        `,
      }}
      frontContentStyle={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
      backHTML={
        <div className="size-full">
          <h1 className="shrink-0 text-center text-sm font-semibold">{question}</h1>
          <div className="flex size-full items-center justify-center overflow-hidden">
            <h1 className="text-md font-bold sm:text-xl">{answer}</h1>
          </div>
        </div>
      }
      backCardStyle={{
        width: "100%",
        overflow: "hidden",
        padding: "30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffedd5",
        backgroundImage:
          "linear-gradient(180deg, rgba(0, 0, 0, 0) -0.11%, rgba(0, 0, 0, 0.048) 100.11%)",
        boxShadow: `
          0px 0px 3px 0px rgba(0, 0, 0, 0.55),
          0px 8px 40px 0px rgba(0, 0, 0, 0.25),
          0px 0px 3px 0px rgba(255, 255, 255, 0.1) inset
        `,
      }}
      backContentStyle={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
      manualFlipRef={flipRef}
    />
  )
}

export default Flashcard
